import React, { useState, useEffect, useCallback } from 'react';

const slides = [
  {
    id: 1,
    image: 'https://i.ibb.co/DPRKGfxW/1.jpg',
    caption: 'Παράσταση',
  },
  {
    id: 2,
    image: 'https://i.ibb.co/Z1RtfPx1/9.jpg',
    caption: 'Εργαστήριο Κίνησης',
  },
];

export default function Carousel() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const next = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrent(c => (c + 1) % slides.length);
      setIsTransitioning(false);
    }, 600);
  }, [isTransitioning]);

  const prev = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrent(c => (c - 1 + slides.length) % slides.length);
      setIsTransitioning(false);
    }, 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <div style={{
      position: 'relative',
      width: '100%',
      height: '90vh',
      overflow: 'hidden',
      background: '#111',
    }}>
      {/* Slides */}
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          style={{
            position: 'absolute',
            inset: 0,
            opacity: i === current ? (isTransitioning ? 0 : 1) : 0,
            transition: 'opacity 0.8s ease',
          }}
        >
          <img
            src={slide.image}
            alt={slide.caption}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              filter: 'brightness(0.72)',
            }}
          />
        </div>
      ))}

      {/* Overlay gradient */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(to bottom, transparent 40%, rgba(26,23,20,0.5) 100%)',
        pointerEvents: 'none',
      }} />

      {/* Caption */}
      <div style={{
        position: 'absolute',
        bottom: '80px',
        left: '64px',
        right: '64px',
      }}>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.65rem',
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.6)',
          marginBottom: '8px',
        }}>
          {String(current + 1).padStart(2, '0')} / {String(slides.length).padStart(2, '0')}
        </p>
        <p style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.4rem',
          fontWeight: 300,
          letterSpacing: '0.08em',
          color: 'rgba(255,255,255,0.85)',
          fontStyle: 'italic',
        }}>
          {slides[current].caption}
        </p>
      </div>

      {/* Arrow controls */}
      <button
        onClick={prev}
        style={{
          position: 'absolute',
          left: '32px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '44px',
          height: '44px',
          border: '1px solid rgba(255,255,255,0.4)',
          background: 'rgba(255,255,255,0.08)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '1rem',
          transition: 'all 0.2s',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
        aria-label="Previous"
      >
        ←
      </button>
      <button
        onClick={next}
        style={{
          position: 'absolute',
          right: '32px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '44px',
          height: '44px',
          border: '1px solid rgba(255,255,255,0.4)',
          background: 'rgba(255,255,255,0.08)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '1rem',
          transition: 'all 0.2s',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
        aria-label="Next"
      >
        →
      </button>

      {/* Dots */}
      <div style={{
        position: 'absolute',
        bottom: '32px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '8px',
      }}>
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            style={{
              width: i === current ? '28px' : '8px',
              height: '2px',
              background: i === current ? 'var(--accent)' : 'rgba(255,255,255,0.4)',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              padding: 0,
            }}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
